import io from 'socket.io-client';

export default class Socket {

  socket: SocketIOClient.Socket

  constructor(url: string) {
    this.socket = io(url, {
      autoConnect: false,
    });
  }

  open() {
    return this.socket.open();
  }

  close() {
    this.socket.close();
  }

  on(eventName: string, callback: Function) {
    return this.socket.on(eventName, callback);
  }

  emit(eventName: string, arg: any[]) {
    return this.socket.emit(eventName, arg);
  }
}
